module.exports = __webpack_public_path__ + "static/media/u35_premium_contract6.a6246515.webp";